import FinanceAdapter from './base';

export default class Till extends FinanceAdapter {
  modelNamePlural = 'tills';
}
